export default __webpack_public_path__ + "img/db2ad67f4efa29009700828889fc8306.png";